import Icon from "@ant-design/icons"
import React from "react"

const eInvoiceSvg = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5 5H8.07692M5 9H8.07692M5 7H7.30769M5 11H7.30769M9.61538 5H10M9.61538 9H10M9.61538 7H10M9.61538 11H10"
            stroke="#6352EF"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12 3.2L10.6929 2L9.42857 2.8L8.14286 2L6.85714 2.8L5.57143 2L4.28571 2.8L3 2V12.8L4.30714 14L5.57143 13.2L6.85714 14L8.14286 13.2L9.42857 14L10.7143 13.2L12 14V3.2Z"
            stroke="#6352EF"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
)

const EInvoiceIcon = (props: any) => <Icon component={eInvoiceSvg} {...props} />

export default EInvoiceIcon
